// src/context/ThemeContext.js
import { createContext, useContext, useEffect, useState } from "react";

// Shared key — all three apps (3000, 3001, 3002) use this same key
// so a theme toggle on any app persists when the user navigates to another.
const THEME_KEY = "busitema-theme";

const ThemeContext = createContext({ theme: "dark", toggleTheme: () => {} });

export function ThemeProvider({ children }) {
  const [theme, setTheme] = useState(() => {
    try {
      const stored = localStorage.getItem(THEME_KEY);
      if (stored) return stored;
      // Respect the OS/browser dark-mode preference on first visit
      if (window.matchMedia?.("(prefers-color-scheme: light)").matches) return "light";
      return "dark";
    } catch {
      return "dark";
    }
  });

  useEffect(() => {
    document.documentElement.setAttribute("data-theme", theme);
    try {
      localStorage.setItem(THEME_KEY, theme);
    } catch {}
  }, [theme]);

  const toggleTheme = () =>
    setTheme((prev) => (prev === "dark" ? "light" : "dark"));

  return (
    <ThemeContext.Provider value={{ theme, toggleTheme }}>
      {children}
    </ThemeContext.Provider>
  );
}

export function useTheme() {
  return useContext(ThemeContext);
}
